import { VIDEO_SELECTOR } from '../../classnames/video';
import checkIOSSafari from '../../utils/checkIOSSafari';
import checkWebMSupport from '../../utils/checkWebMSupport';
import Base from './base';

export default class Video extends Base {
  selector = VIDEO_SELECTOR;
  sourceTagName = 'source';

  load = (element) => {
    const source = element.querySelector(this.sourceTagName);
    const { src, srcWebm } = source.dataset;
    const { delay } = element.dataset;
    const isIOSSafari = checkIOSSafari();
    const isWebMSupported = checkWebMSupport();

    source.src = !isIOSSafari && isWebMSupported && srcWebm ? srcWebm : src;

    if (delay) {
      this.setupDelayLoop(element, delay);
    }
  };

  setupDelayLoop = (video, delay) => {
    video.addEventListener('ended', () => {
      setTimeout(() => (
        video.play()
      ), delay);
    });
  };
}
